var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { makeAccountBridgeReceive, makeScanAccounts, makeSync, } from "@ledgerhq/coin-framework/bridge/jsHelpers";
import { patchOperationWithHash } from "@ledgerhq/coin-framework/operation";
import { submitExtrinsic } from "../api";
import { getPreloadStrategy, preload, hydrate } from "../preload";
import { getAccountShape } from "../js-synchronisation";
import createTransaction from "../js-createTransaction";
import prepareTransaction from "../js-prepareTransaction";
import getTransactionStatus from "../js-getTransactionStatus";
import estimateMaxSpendable from "../js-estimateMaxSpendable";
import buildSignOperation from "../js-signOperation";
import getAddress from "../hw-getAddress";
import { loadPolkadotCrypto } from "../polkadot-crypto";
import getAddressWrapper from "@ledgerhq/coin-framework/bridge/getAddressWrapper";
var updateTransaction = function (t, patch) { return (__assign(__assign({}, t), patch)); };
/**
 * Broadcast the signed transaction
 * @param {signature: string, operation: string} signedOperation
 */
var broadcast = function (_a) {
    var _b = _a.signedOperation, signature = _b.signature, operation = _b.operation;
    return __awaiter(void 0, void 0, void 0, function () {
        var hash;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, loadPolkadotCrypto()];
                case 1:
                    _c.sent();
                    return [4 /*yield*/, submitExtrinsic(signature)];
                case 2:
                    hash = _c.sent();
                    return [2 /*return*/, patchOperationWithHash(operation, hash)];
            }
        });
    });
};
export function buildCurrencyBridge(deviceCommunication) {
    var scanAccounts = makeScanAccounts({
        getAccountShape: getAccountShape,
        deviceCommunication: deviceCommunication,
        getAddressFn: getAddress
    });
    return {
        getPreloadStrategy: getPreloadStrategy,
        preload: preload,
        hydrate: hydrate,
        scanAccounts: scanAccounts
    };
}
export function buildAccountBridge(deviceCommunication) {
    var receive = makeAccountBridgeReceive(getAddressWrapper(getAddress), deviceCommunication);
    var signOperation = buildSignOperation(deviceCommunication);
    var sync = makeSync({ getAccountShape: getAccountShape });
    return {
        estimateMaxSpendable: estimateMaxSpendable,
        createTransaction: createTransaction,
        updateTransaction: updateTransaction,
        getTransactionStatus: getTransactionStatus,
        prepareTransaction: prepareTransaction,
        sync: sync,
        receive: receive,
        signOperation: signOperation,
        broadcast: broadcast
    };
}
//# sourceMappingURL=js.js.map